(function($) {


    // Complete order
    function request_reset(e){

        e.preventDefault()

        let $form = $(this);

        let data = $form.serializeArray();
        let action = $form.find('input[name="action"]').val();
        let url = ghostpress_params.ajax_url + "&action="+action;


        gp_ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: data,
            show_loading: true
        })
            .done((response, textStatus, jqXHR) => {

                let success = response.success

                if(!success){
                    // Scroll to error notices
                    $("html").animate({
                        scrollTop: $(".notices").offset().top - 100
                    }, 1000);
                }else if(action === 'customer_reset_password'){
                    // open login modal
                    $('.open-login-modal').click();
                }

            })

    }

    let $form = $("form.lost_reset_password");

    $form.on("submit", request_reset);

})(jQuery);